/**
 * @module errorHandler
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
/* tslint:disable:no-any */ // We need to be able to allow developers send any payload the want
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { APIError, ApiProperties } from '@support/api/common/error.interface';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { HttpErrorResponse } from '@angular/common/http';

/**
 * Service to handle all Http Errors, codes, status, etc.
 *
 */
@Injectable()
export class HttpEventInterceptorService {
  /**
   * Subject for api failures.
   *
   */
  public code: Subject<APIError>;
  /**
   * Subject for api 404 failures.
   */
  public apiNotFound: Subject<void>;

  /**
   * Creates an instance of HttpEventInterceptorService.
   */
  constructor(private objectService: ObjectService) {
    this.code = new Subject<APIError>();
    this.apiNotFound = new Subject<void>();
  }

  /**
   * handleHttpError Method
   * This method is to check if there is any error code of http exist
   * if yes then creating Observable so that it can be subscribe from public method.
   *
   * API 404 errors are handled differently and so we have a second subscriber.
   */
  public handleHttpError(
    httpError: HttpErrorResponse,
    endpoint: string,
    properties?: ApiProperties
  ): void {
    if (!httpError.ok) {
      const errorObj: APIError = httpError.error
        ? Array.isArray(httpError.error)
          ? httpError.error[0]
          : httpError.error
        : {};
      errorObj.endpoint = endpoint;
      errorObj.properties = {
        activityId: this.objectService.get(properties, 'activityId'),
        endUrl: this.objectService.get(properties, 'endUrl'),
      };
      this.code.next(errorObj);
    }
  }

  /**
   * listenHttpErrors Method
   * This method return observable for error codeso that
   * it can be subscribe from public method
   *
   */
  public listenHttpErrors(): Observable<APIError> {
    return this.code.asObservable();
  }

  /**
   * Specifcally listens for 404 errors from API failures.
   *
   */
  public listenApiFailure(): Observable<void> {
    return this.apiNotFound.asObservable();
  }
}
